import request from './request'

// 相关API
export const Api = {
	// banner
	bannerApi() {
		return request({
			url: '/t/banner/list',
			method: 'get'
		})
	},
	//案例
	casesApi(params) {
		return request({
			url: '/t/cases/list',
			method: 'get',
			params: params
		})
	},
	//案例详情
	casesDetailsApi(id) {
		return request({
			url: `/t/cases/${id}`,
			method: 'get',
		})
	},
	//党建
	cpcApi() {
		return request({
			url: '/t/cpc/list',
			method: 'get',
		})
	},
	//党建详情
	cpcDetailsApi(id) {
		return request({
			url: `/t/cpc/${id}`,
			method: 'get',
		})
	},
	//招聘
	hiresApi() {
		return request({
			url: '/t/hires/list',
			method: 'get',
		})
	},
	//招聘详情
	hiresDetailsApi(id) {
		return request({
			url: `/t/hires/${id}`,
			method: 'get',
		})
	},
	//资讯动态
	newsApi(params) {
		return request({
			url: '/t/news/list',
			method: 'get',
			params: params
		})
	},
	//资讯详情
	newsDetailsApi(id) {
		return request({
			url: `/t/news/${id}`,
			method: 'get',
		})
	},
	//服务类型
	servicesApi(params) {
		return request({
			url: '/t/services/list',
			method: 'get',
			params: params
		})
	},
	//服务类型详情
	servicesDetailsApi(id) {
		return request({
			url: `/t/services/${id}`,
			method: 'get',
		})
	},
	//视频类型
	videoApi(params) {
		return request({
			url: '/t/videos/list',
			method: 'get',
			params: params
		})
	},
	//视频详情
	videoDetailsApi(id) {
		return request({
			url: `/t/videos/${id}`,
			method: 'get',
		})
	},
	//集团荣誉
	honorApi(params) {
		return request({
			url: '/t/honor/list',
			method: 'get',
			params: params
		})
	},
	//合作伙伴
	partnerApi(params) {
		return request({
			url: '/t/partner/list',
			method: 'get',
			params: params
		})
	},
}